import React, { useEffect, useRef, useState } from 'react';

import { formatValueForPhone, replaceValueForPhone } from './helpers/phoneDecorator';

const INITIAL = 7;

// eslint-disable-next-line react/display-name,sonarjs/cognitive-complexity
const phoneDecorator = Input => props => {

    const {
        placeholder,
        errorMessage,
        className,
        onChange,
        name,
        initialValue,
        hasError,
        ...rest
    } = props;

    const input = useRef({});

    const [isValid, setIsValid] = useState(false);
    const [isNotValid, setIsNotValid] = useState(false);
    const [isTouch, setIsTouch] = useState(false);
    const [value, setValue] = useState(initialValue);

    const onChangeHandler = event => {
        event.preventDefault();
        const incomingValue = event.target.value;
        const isAutocomplete = !event?.nativeEvent?.inputType;
        const newValue = replaceValueForPhone(incomingValue, isAutocomplete);
        setValue(newValue);
        checkValidate(newValue);
    };

    const onFocusHandler = () => {
        if (!isTouch) {
            setIsTouch(true);
        }
        if (!value || !value.length) {
            setValue(INITIAL);
            const timeout = setTimeout(() => {
                input.current.setSelectionRange(3, 3);
                clearTimeout(timeout);
            }, 150);
        }
    };

    const onBlurHandler = () => {
        if (value.length !== 11) {
            setIsNotValid(true);
        }
    };

    const checkValidate = value => {
        if (value && value.length === 11) {
            setIsValid(true);
            setIsNotValid(false);
        } else {
            setIsValid(false);
        }
    };

    const clearInput = () => {
        setIsTouch(false);
        setValue('');
        setIsValid(false);
    };

    useEffect(() => {
        if (value && value !== INITIAL) {
            onChange({ value, isValid, clearInput });
        }
    }, [value, isValid]);

    useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    useEffect(() => {
        checkValidate(value);
    }, [value]);

    return (
        <Input
            value={(isTouch || Boolean(value)) ? formatValueForPhone(value) : ''}
            name={name}
            placeholder={placeholder}
            showText={true}
            errorMessage={errorMessage}
            isNotValid={hasError || isNotValid}
            inputType='phone'
            isValid={isValid}
            className={'ym-disable-keys ' + className}
            onChange={onChangeHandler}
            onPaste={onChangeHandler}
            onFocus={onFocusHandler}
            onBlur={onBlurHandler}
            ref={input}
            {...rest}
        />
    );
};

phoneDecorator.defaultProps = {
    placeholder: 'Номер телефона',
    name: 'phone',
    errorMessage: 'Введите телефон в формате +7 (999) 999-99-99',
    className: '',
    onChange: () => null,
    initialValue: '',
    hasError: false,
};

export default phoneDecorator;
